/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PncTypeEnum {
    UNKNOWN = '',
    PLANNER = 'PNC_PLANNER',
    F2_MISSING_PARTS = 'PNC_F2_MISSING',
    PARTNER = 'PNC_PARTNER',
    AI_CHANGE = 'PNC_AI_CHANGE'
}
